import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import { RowExportTypePdf } from "types"
import { DataList } from "../../types"

type UseExportPdf = {
  data: DataList[]
}

export const useExportPdf = ({ data, }: UseExportPdf) => {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "PROJECT", key: "project", width: 15 },
    { header: "COUNTRY", key: "country", width: 15 },
    { header: "PROVINCE", key: "province", width: 15 },
    { header: "SUBDISTRICT", key: "subdistrict", width: 25 },
    { header: "VILLAGE", key: "village", width: 25 },
    { header: "ADDRESS", key: "address", width: 25 },
    { header: "NOTE", key: "note", width: 15 },
  ]

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      project: item.project_name,
      country: item.country_name,
      province: item.province_name,
      subdistrict: item.subdistrict_name,
      village: item.village_name,
      address: item.address ?? "",
      note: item.note ?? "",
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          data={dataMap}
          column={columns}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = 'project-jobs.pdf'
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column,
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>PROJECT/JOBS</Text>
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}>
        </View>
      </Page>
    </Document>
  )
}
